module.exports = __webpack_public_path__ + "static/stop-e39ba4f27d986cb46c02c4a3a5050c99.png";